export default {
  controls: [
    {
      title: 'controls.siderails',
      icon: 'icon-postranice-ave',
      animation: 'siderails',
      autoHideLabel: true,
      visible: true,
      toggle: true
    },
    {
      title: 'controls.rectable_steel_tray',
      icon: 'icon-rectable-steel-tray',
      animation: 'rectable_steel_tray',
      autoHideLabel: true,
      visible: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'Ergonomic positiong',
      style: 'thumbnails',
      image: '01_2_Linet_Ave_2_Retractable_Foot_Section.jpg',
      explanation: 'ergonomic_positiong'
    },
    {
      title: 'Safety & comfort',
      style: 'thumbnails',
      image: 'Safety_Comfort.jpg',
      explanation: 'safety_comfort'
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.safety',
      style: 'thumbnails',
      image: 'safety.jpg',
      explanation: 'safety',
    },
    {
      title: 'key_features.positioning',
      style: 'thumbnails',
      image: 'positioning.jpg',
      explanation: 'positioning'
    },
    {
      title: 'key_features.accesories',
      style: 'thumbnails',
      image: 'accesories.jpg',
      explanation: 'accesories',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'comfort.jpg',
      explanation: 'comfort',
    },
  ],
  modifications: [
		{
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.regular',
            image: 'colors/Pink.jpg',
            modelParts: [
              {
                name: 'seatDuo_geoPIV',
                visible: false
              },
              {
                name: 'duocoat_geoPIV',
                visible: false
              },
              {
                name: 'legsDuo_geoPIV',
                visible: false
              },
              {
                name: 'potiskDuoCoat_geoPIV',
                visible: false
              },
							{
                name: 'podhlavnik03_geoPIV',
                visible: true
              },
              {
                name: 'Polstrovani_podnozka_velkaPIV',
                visible: true
              },
              {
                name: 'Polstrovani_sedaci_castPIV',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.duocoat',
            image: 'colors/DuoCoat.jpg',
            modelParts: [
              {
                name: 'seatDuo_geoPIV',
                visible: true
              },
              {
                name: 'duocoat_geoPIV',
                visible: true
              },
              {
                name: 'legsDuo_geoPIV',
                visible: true
              },
              {
                name: 'potiskDuoCoat_geoPIV',
                visible: true
              },
              {
                name: 'podhlavnik03_geoPIV',
                visible: false
              },
              {
                name: 'Polstrovani_podnozka_velkaPIV',
                visible: false
              },
              {
                name: 'Polstrovani_sedaci_castPIV',
                visible: false
              }
            ]
          }
        ]
      }
    },
    {
      title: 'Color',
      icon: 'icon-colors',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'Pink',
            image: 'colors/Pink.jpg',
            color: 'pink'
          },
          {
            title: 'Orange',
            image: 'colors/Orange.jpg',
            color: 'orange'
          },
          {
            title: 'Yellow',
            image: 'colors/Yellow.jpg',
            color: 'yellow'
          },
          {
            title: 'blue',
            image: 'colors/Blue.jpg',
            color: 'blue'
          },
          {
            title: 'Violet',
            image: 'colors/Violet.jpg',
            color: 'violet'
          }
        ]
      }
    }
  ]
}